import { render, staticRenderFns } from "./RecaudacionConsumoAgua.vue?vue&type=template&id=ab4a4de8"
import script from "./RecaudacionConsumoAgua.vue?vue&type=script&lang=ts"
export * from "./RecaudacionConsumoAgua.vue?vue&type=script&lang=ts"
import style0 from "./RecaudacionConsumoAgua.vue?vue&type=style&index=0&id=ab4a4de8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports